import React from "react";

export default class FilterComponent extends React.Component {

    constructor(props) {
        super(props);
    }
}
